var isAtomicService = function () {
    var atomicService = false;
    if (window.CSNativeObject && window.CSNativeObject.getOSType) {
        var osType = window.CSNativeObject.getOSType().toLowerCase();
        atomicService = osType === 'harmony_atomicservice';
    }
    return atomicService;
};
/**
 * 判断是否是南航app运行环境
 * @returns {boolean}
 */
export default function isCsairApp() {
    return window.CSNativeObject && !isAtomicService() ? true : false;
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/app/isCsairApp.js
// module id = null
// module chunks = 